import styled from 'styled-components';

export const DivFilterTagsBlock = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
`;

export const DivFilterTags = styled.div`
  display: inline-block;
  margin-left: 20px;
`;

export const DivTag = styled.div`
  display: inline-block;
  margin: 2px 4px;
`;

export const DivTagClear = styled(DivTag)`
  margin: 0 4px;

  & > button {
    min-height: 27px;
  }
`;
